<template>
  <div class="home-page">
    <!-- 学习记录区域 -->
    <section class="section" v-if="history.length > 0">
      <div class="section-header">
        <h3>课件播放记录</h3>
        <div class="more-link" @click="more()">查看更多</div>
      </div>
      <div class="record-list">
        <div class="record-card" v-for="(item, index) in history" @click="course(item.news_id, item.name)" :key="index">
          <div class="card-tag" :class="[
            item.type === 1
              ? 'tag-high'
              : item.type === 2
                ? 'tag-middle'
                : 'tag-low',
          ]">
            {{
              item.type === 1
                ? "高级课程"
                : item.type === 2
                  ? "中级课程"
                  : "初级课程"
            }}
          </div>
          <div class="card-content">
            <div class="card-info">
              <div class="name">{{ item.name }}</div>
              <p class="card-time">{{ item.study_at }}学习</p>
              <p class="card-desc">{{ item.remark }}</p>
            </div>
            <div class="card-cover">
              <img :src="item.cover || defaultImg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 直播课区域 -->
    <section class="section" v-if="lives.length > 0">
      <div class="section-header">
        <h3>直播课</h3>
        <div class="more-link" @click="moreLive()">更多直播</div>
      </div>
      <div class="live-list">
        <div class="live-card" v-for="(item, index) in lives" :key="index" @click="handleLiveClick(item.id)">
          <div class="live-logo">
            <img :src="item.cover || defaultImg" alt="logo" />
          </div>
          <div class="live-info">
            <h4>{{ item.name }}</h4>
            <div class="live-status" :class="{
              'status-live': item.status === 1,
              'status-wait': item.status === 0,
              'status-end': item.status === 2,
            }">
              <span class="status-dot"></span>
              <span>{{
                item.status === 0
                  ? "未开播"
                  : item.status === 1
                    ? "直播中"
                    : item.status === 2
                      ? "已结束"
                      : ""
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 多弹窗：每个课件独立一个可最小化的弹窗 ===== -->
    <min-dialog v-for="dialog in dialogs" :key="'dialog-' + dialog.id" :visible.sync="dialog.visible"
      :title="dialog.title" width="70%" :minimize-index="getMinimizeIndex(dialog.id)" :dialog-id="dialog.id"
      @close="removeDialog(dialog.id)" @minimize="onMinimize" @restore="onRestore">
      <iframe :src="dialog.url" frameborder="0" allowfullscreen style="width:100%; height:100%; border:none;"></iframe>
    </min-dialog>

    <!-- 已结束直播：video 播放器 -->
    <div v-if="showPlayer && liveStatus === 2" class="video-container">
      <div class="video-header">
        <h3>{{ currentLiveTitle }}</h3>
        <button class="close-btn" @click="closePlayer">× 关闭</button>
      </div>
      <video class="live-video" controls controlslist="nodownload noplaybackrate" disablePictureInPicture autoplay
        :src="currentVideoUrl"></video>
    </div>

    <!-- 推荐课程区域 -->
    <section class="section">
      <div class="section-header">
        <h3 v-if="pickFileList.length !== 0">课程</h3>
      </div>
      <div class="pickFileList">
        <div class="item" v-for="(item, index) in pickFileList" @click="pickHistory(item, index)" :key="index">
          {{ item.name }}
        </div>
      </div>
      <div class="course-list">
        <!-- 文件夹 -->
        <div class="file_item" v-for="(item, index) in sublist" @dblclick="openfile(item)" :key="'key' + index">
          <div class="img">
            <img src="@/assets/file.png" alt="" />
          </div>
          {{ item.name }}
        </div>
        <!-- 课件卡片 -->
        <div class="course-card" v-if="pickFileList.length !== 0" v-for="(item, index) in list" :key="index">
          <div class="course-cover">
            <img :src="item.cover || defaultImg" alt="" />
          </div>
          {{ item.name }}
          <div class="course-info">
            <div class="mask"></div>
            <button class="join-btn" @click.stop="openJoinDialog(item.id)">
              加入学习路线
            </button>
            <button class="join-btn" style="background: #8c33ff" @click.stop="course(item.id, item.name)">
              阅读
            </button>
            <button class="join-btn" style="background: rgb(1 187 60)" v-if="item.can_upload == 1"
              @click.stop="download(item.id)">
              下载
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- 无数据 -->
    <div class="empty-state" v-if="list.length === 0 && sublist.length == 0">
      <img class="empty-image" src="@/assets/empty-data.png" alt="暂无数据" />
      <p class="empty-text">暂无课程数据</p>
    </div>

    <join-dialog ref="JoinDialog"></join-dialog>
  </div>
</template>

<script>
import {
  newsHistory,
  livesList,
  livesInfo,
  newsList,
  newsCate,
  newsInfo,
  userInfo,
} from "@/api/api";
import joinDialog from "@/components/joinDialog.vue";
import MinDialog from '@/components/MinDialog.vue'

export default {
  name: "Home",
  components: {
    joinDialog,
    MinDialog
  },
  data() {
    return {
      defaultImg: require('@/assets/defaultImg.png'),
      history: [],
      lives: [],
      list: [],
      showPlayer: false,
      liveStatus: 0,
      currentLiveUrl: "",
      currentVideoUrl: "",
      currentLiveTitle: "",
      info: {},
      name: "",
      cate: [],
      cateids: "",
      fileList: {},
      sublist: [],
      alldata: [],
      pickFileList: [],
      page: 1,
      limit: 18,
      // ===== 多弹窗管理 =====
      dialogs: [],
      dialogId: 0,
      // 记录每个弹窗的最小化状态 { dialogId: true/false }
      minimizeStates: {},
      // ===== 防重复点击锁 =====
      loadingDialogs: new Set()
    };
  },
  mounted() {
    this.newsHistory();
    this.livesList();
    this.newsList();
    this.userInfo();
  },
  methods: {
    generateRandomString(length = 32, charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
      // 1. 获取当前时间戳（毫秒级）
      const timestamp = Date.now().toString();

      // 2. 生成随机数字和字符串（补充材料）
      const randomPart1 = Math.random().toString(36).substring(2, 10); // 随机字母数字
      const randomPart2 = Math.random().toString(10).substring(2, 8); // 纯随机数字
      const randomPart3 = String.fromCharCode(
        65 + Math.floor(Math.random() * 26),
        97 + Math.floor(Math.random() * 26),
        48 + Math.floor(Math.random() * 10)
      ); // 随机大小写字母 + 数字各一个

      // 3. 合并所有素材
      let combined = timestamp + randomPart1 + randomPart2 + randomPart3;

      // 4. 如果合并后的长度不足目标长度，继续补充随机字符
      while (combined.length < length) {
        combined += Math.random().toString(36).substring(2, 10);
      }

      // 5. 截取所需长度
      combined = combined.substring(0, length);

      // 6. 打乱顺序（Fisher-Yates 洗牌算法）
      const arr = combined.split('');
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }

      // 7. 可选：使用自定义字符集过滤（如果传入自定义字符集）
      if (charset !== 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
        // 如果自定义字符集，从结果中筛选可用字符，不足则补充
        let filtered = arr.filter(ch => charset.includes(ch)).join('');
        while (filtered.length < length) {
          const extra = generateRandomString(length - filtered.length, charset);
          filtered += extra;
        }
        return filtered.substring(0, length);
      }

      return arr.join('');
    },
    // ===== 打开课件弹窗（核心方法）=====
    course(id, title) {
      // 检查是否已打开相同课件（用 newsId 判断）
      const existing = this.dialogs.find(d => d.newsId === id)
      console.log(existing, 'existing')
      if (existing) {
        // 如果已最小化，需要触发还原（让 MinDialog 内部 isMinimize=false）
        if (this.minimizeStates[existing.id]) {
          // 方法1：直接操作 MinDialog 实例（不好）
          // 方法2：先关闭再重新打开（粗暴但有效）
          // 方法3：emit 事件让 MinDialog 自己处理

          // 最好的方式：把 visible 设为 false 再设为 true，强制重新渲染
          this.$set(existing, 'visible', false)
          this.$nextTick(() => {
            this.$set(existing, 'visible', true)
            this.$set(this.minimizeStates, existing.id, false)
          })
        } else if (!existing.visible) {
          this.$set(existing, 'visible', true)
        }
        return
      }

      // ===== 防重复点击：如果正在加载中，直接忽略 =====
      if (this.loadingDialogs.has(id)) {
        return
      }

      this.loadingDialogs.add(id)

      newsInfo(id).then((res) => {
        let url = "";
        if (res.data.url) {
          if (res.data.url.startsWith("http")) {
            url = `https://ow365.cn/?i=37451&ssl=0&n=5&htool=1&draw=3&fname=${this.generateRandomString(10)}&furl=${encodeURIComponent(res.data.url)}`;
          } else {
            url = res.data.url;
          }
        }
        console.log('open1', url);
        console.log('open1', res);
        this.dialogId++;
        const newId = this.dialogId;
        this.dialogs.push({
          id: newId,
          newsId: id,
          title: title || res.data.name || '未命名课件',
          url: url,
          visible: true
        });

        this.$set(this.minimizeStates, newId, false);
      }).catch(err => {
        console.error('获取课件信息失败:', err);
        this.$message.error('加载课件失败，请重试');
      }).finally(() => {
        this.loadingDialogs.delete(id)
      });
    },

    // 计算最小化弹窗的索引位置（用于横向排列不重叠）
    getMinimizeIndex(dialogId) {
      // 获取所有已最小化的弹窗 ID，按打开顺序排序
      const minimizedIds = Object.keys(this.minimizeStates)
        .filter(id => {
          const dialog = this.dialogs.find(d => d.id == id)
          return this.minimizeStates[id] === true && dialog && dialog.visible
        })
        .map(Number)
        .sort((a, b) => a - b)

      const index = minimizedIds.indexOf(dialogId)
      return index >= 0 ? index : -1
    },

    // 监听最小化状态变化
    onMinimize({ id, isMinimize }) {
      this.$set(this.minimizeStates, id, isMinimize)
    },

    // 监听还原事件
    onRestore({ id }) {
      this.$set(this.minimizeStates, id, false)
    },

    // 关闭弹窗
    removeDialog(id) {
      this.dialogs = this.dialogs.filter(d => d.id !== id)
      this.$delete(this.minimizeStates, id)
    },

    // ===== 加入学习路线弹窗 =====
    openJoinDialog(news_id) {
      this.$refs.JoinDialog.show(news_id)
    },

    // ===== 以下保持原有逻辑 =====
    pickHistory(e, index) {
      let list = []
      for (let i in this.pickFileList) {
        if (i <= index) {
          list.push(this.pickFileList[i])
        }
      }
      this.pickFileList = list
      this.cateids = e.id
      if (e.sub && e.sub.length > 0) {
        this.sublist = e.sub
      } else {
        this.sublist = []
      }
      this.limit = 9999999999999999;
      this.newsList()
    },

    openfile(e) {
      console.log('打开文件夹')
      if (this.pickFileList.length == 0) {
        this.pickFileList.push(this.fileList.item)
      }
      this.pickFileList.push(e)
      this.cateids = e.id
      if (e.sub && e.sub.length > 0) {
        this.sublist = e.sub
      } else {
        this.sublist = []
      }
      if (this.pickFileList.length === 3) {
        this.limit = 9999999999999999
      } else {
        this.limit = 9999999999999999
      }
    
      this.newsList()
    },

    injectIframeProtection() {
      console.log("window.disableDevtool", window)
    },

    handleSearch(data) {
      this.name = data
      this.livesList()
      this.newsList()
    },

    handleMenuSearch(data) {
      this.cateids = data.cateids
      this.fileList = data
      if (data.item && data.item.sub && data.item.sub.length > 0) {
        this.sublist = data.item.sub
        this.pickFileList = []
      } else {
        this.sublist = []
        this.pickFileList = []
        this.limit = 9999999999999999
      }
      console.log("alldata", data)
      this.newsList()
    },

    userInfo() {
      userInfo().then((res) => {
        this.info = res.data
      })
    },

    newsHistory() {
      let params = {
        page: this.page,
        limit: 6,
      }
      newsHistory(params).then((res) => {
        this.history = res.data.list
      })
    },

    livesList() {
      let params = {
        page: this.page,
        limit: this.limit,
        name: this.name,
      }
      livesList(params).then((res) => {
        this.lives = res.data.list
      })
    },

    handleLiveClick(id) {
      // 关闭之前的播放器
      this.closePlayer()

      livesInfo(id).then((res) => {
        this.liveStatus = res.data.status
        if (res.data.status === 2) {
          this.currentVideoUrl = res.data.video_url
        } else {
          if (res.data.url.startsWith("https://") || res.data.url.startsWith("http://")) {
            this.currentLiveUrl = `https://ow365.cn/?i=37451&ssl=0&n=5&htool=1&draw=3&fname=${this.generateRandomString(10)}&furl=${res.data.url}`
          }
        }
        this.currentLiveTitle = res.data.name
        this.showPlayer = true
      })
    },

    download(id) {
      newsInfo(id).then((res) => {
        const encodedUrl = res.data.url
        const displayName = decodeURIComponent(encodedUrl)
        console.log("display", displayName)
        window.open(displayName, "_blank")
        console.log('open2', encodedUrl);
      })
    },

    closePlayer() {
      this.showPlayer = false
      this.currentLiveUrl = ""
      this.currentVideoUrl = ""
      this.currentLiveTitle = ""
      this.liveStatus = 0
    },

    newsList() {
      this.list = []
      let params = {
        page: this.page,
        limit: this.limit,
        name: this.name,
        cateids: this.cateids,
      }
      // if (this.sublist.length === 0) {
        newsList(params).then((res) => {
          let list = res.data.list;
          let arr = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].cateids[list[i].cateids.length - 1] == this.cateids) {
              arr.push(list[i]);
            }
          }
          this.list = arr;
        })
      // }
    },

    more() {
      this.$router.push({ path: "/record" })
    },

    moreLive() {
      this.$router.push({ path: "/live" })
    },

    moreReferral() {
      this.$router.push({ path: "/referral" })
    },
  },
}
</script>

<style lang="less" scoped>
.home-page {
  padding: 0;
}

.section {
  margin-bottom: 40px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      font-size: 18px;
      font-weight: 600;
      color: #1e293b;
      margin: 0;
    }

    .more-link {
      font-size: 14px;
      color: #3a44f7;
      cursor: pointer;
    }
  }
}

.record-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  .record-card {
    background: #fff;
    border-radius: 12px;
    padding: 15px;
    cursor: pointer;
    border: 1px solid #f1f1f1;

    .card-tag {
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;
      display: inline-block;
      float: left;

      &.tag-high {
        background: #fef2f2;
        color: #ef4444;
      }

      &.tag-middle {
        background: #fffbeb;
        color: #f59e0b;
      }

      &.tag-low {
        background: #eff6ff;
        color: #3a44f7;
      }
    }

    .card-content {
      display: flex;
      width: 100%;
      position: relative;

      .card-info {
        flex: 1;

        .name {
          font-size: 14px;
          color: #1e293b;
          margin: 15px 0;
          text-align: left;
        }

        .card-time {
          font-size: 12px;
          color: #94a3b8;
          margin-bottom: 15px;
          text-align: left;
        }

        .card-desc {
          font-size: 12px;
          color: #64748b;
          text-align: left;
        }
      }

      .card-cover {
        width: 80px;
        height: 80px;
        border-radius: 12px;
        position: absolute;
        top: -20px;
        right: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}

.live-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.live-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  border: 1px solid #f1f1f1;
}

.live-logo {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.live-info {
  flex: 1;
}

.live-info h4 {
  margin: 0 0 6px 0;
  font-size: 14px;
  color: #1e293b;
  text-align: left;
}

.live-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-live {
  color: #22c55e;

  .status-dot {
    background: #22c55e;
  }
}

.status-wait {
  color: #ef4444;

  .status-dot {
    background: #ef4444;
  }
}

.status-end {
  color: #94a3b8;

  .status-dot {
    background: #94a3b8;
  }
}

.course-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  .course-card {
    width: 160px;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #f1f1f1;
    position: relative;
    height: 160px;

    .course-cover {
      width: 100%;
      height: 100px;
      overflow: hidden;
      line-height: 1;
      margin-bottom: 20px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
    }

    .course-info {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 20px;
      display: none;
      flex-direction: column;

      .join-btn {
        display: flex;
        align-items: center;
        padding: 8px 10px;
        position: relative;
        justify-content: center;
        font-size: 14px;
        color: #fff;
        background: #3355ff;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom: 10px;

        &:hover {
          opacity: 0.9;
        }
      }
    }

    &:hover .course-info {
      display: flex;
    }
  }
}

/* 视频播放器（直播已结束） */
.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  background: #000;
}

.video-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #2f54eb;
  color: #fff;
  height: 56px;
  flex-shrink: 0;
}

.live-video {
  flex: 1;
  border: none;
  height: 50%;
}

.close-btn {
  padding: 6px 12px;
  background: #fff;
  color: #2f54eb;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 20px;

  .empty-image {
    width: 200px;
    opacity: 0.7;
  }

  .empty-text {
    font-size: 16px;
    color: #94a3b8;
  }
}

.file_item {
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 13px;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #f4f7ff;
  }

  .img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 120px;

    img {
      width: 80px;
      height: 80px;
    }
  }
}

.pickFileList {
  display: flex;
  align-content: center;
  margin-bottom: 20px;

  .item {
    font-size: 18px;
    cursor: pointer;
    font-weight: bold;

    &::after {
      content: ">";
      color: #333 !important;
      display: inline-block;
      transform: scaleX(0.6);
      margin: 0 10px;
    }

    &:hover {
      color: #3a86f7;
    }
  }
}
</style>
